import btnStyles from '../styles/buttons.module.css';
import styles from '../styles/ReviewsListing.module.css';
import Image from 'next/image';
import { AuditSources } from '../types';
import { getSourceImage } from '../helpers';

type Props = {
  onNext: () => void;
  onRetry: () => void;
  auditSources: AuditSources;
};

const ReviewsListing = ({ onNext, onRetry, auditSources }: Props) => (
  <div className={styles.reviewsListing}>
    <h2>We found the listings below</h2>
    <ul>
      {auditSources.map(
        ({ sourceName, companyName, address, url }) =>
          companyName && (
            <li key={sourceName}>
              <div className={styles.imageWrapper}>
                <Image
                  src={getSourceImage(sourceName)}
                  alt={sourceName}
                  width={40}
                  height={40}
                  layout="fixed"
                />
              </div>
              <span>
                {companyName} - {address}
              </span>
              <a href={url} target="_blank" rel="noreferrer">
                View
              </a>
            </li>
          )
      )}
    </ul>
    <p className={styles.note}>
      Not happy with the results?{' '}
      <a href="#" onClick={onRetry}>
        Try another search
      </a>
    </p>
    {!!auditSources.length && (
      <button className={btnStyles.btnBlue} onClick={onNext}>
        Continue
      </button>
    )}
  </div>
);

export default ReviewsListing;
